document.querySelectorAll('.menu-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const content = button.nextElementSibling;

    // 他のセクションを閉じる処理
    document.querySelectorAll('.menu-content.open').forEach(openContent => {
      if (openContent !== content) {
        openContent.classList.remove('open');
        openContent.style.maxHeight = null;
      }
    });

    document.querySelectorAll('.menu-toggle.is-open').forEach(openButton => {
      if (openButton !== button) {
        openButton.classList.remove('is-open');
      }
    });

    // 現在のボタンとコンテンツをトグル
    button.classList.toggle('is-open');

    if (content.classList.contains('open')) {
      content.classList.remove('open');
      content.style.maxHeight = null;
    } else {
      content.classList.add('open');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });
});


// 定期購買
// const subscription = document.getElementById('subscription');
// const applySubscription = document.getElementById('applysubscription');

// if (subscription && applySubscription) {
//   applySubscription.appendChild(subscription);
// }